<template>
  <div
    v-if="selectedReporting !== null && initiallist[selectedReporting]?.periodicityList && (billingSubscribedValueModel === 1 || [2, 3, 4, 5, 6].includes(selectedReporting))"
    class="mb-5"
  >
    <span class="block text-sm font-medium leading-6 text-surface-700 mb-2"> Périodicité </span>
    <Dropdown
      v-model="selectedPeriodicityModel"
      :options="periodicities"
      show-clear
      option-label="name"
      option-value="value"
      placeholder="-- Sélectionner la périodicité --"
      class="w-full md:w-14rem"
    />
    <Message v-if="errorMessagePeriodicity" severity="error" icon="pi pi-times-circle" variant="simple" size="small" class="mb-2">
      {{ errorMessagePeriodicity }}
    </Message>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.placerList" class="mb-5">
    <span class="block text-sm font-medium leading-6 text-surface-700 mb-2"> Placier </span>
    <Dropdown
      v-model="selectedPlacerModel"
      :options="placers"
      show-clear
      option-label="name"
      option-value="value"
      placeholder="-- Sélectionner un placier --"
      class="w-full md:w-14rem"
    />
    <Message v-if="errorMessagePlacer" severity="error" icon="pi pi-times-circle" variant="simple" size="small" class="mb-2">
      {{ errorMessagePlacer }}
    </Message>
  </div>

  <div v-if="selectedReporting === 1">
    <span class="block text-base font-bold leading-6 text-surface-800 mt-2 mb-1"> Onglets à exporter </span>
    <Message v-if="errorMessageOnglet" severity="error" icon="pi pi-times-circle" variant="simple" size="small" class="mb-3">
      {{ errorMessageOnglet }}
    </Message>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.absencesubscribedcheck" class="mb-5">
    <i v-tooltip="message1" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="absencesubscribedcheckvalueModel" input-id="absencesubscribedcheckvalue" name="absencesubscribedcheckvalue" :binary="true" :true-value="1" :false-value="0" />
    <label for="absencesubscribedcheckvalue" class="text-surface-800 ml-3 cursor-pointer"> Présence Abonnés </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.billingvolantcheck" class="mb-5">
    <i v-tooltip="message2" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="billingvolantcheckvalueModel" input-id="billingvolantcheckvalue" name="billingvolantcheckvalue" :binary="true" :true-value="1" :false-value="0" />
    <label for="billingvolantcheckvalue" class="text-surface-800 ml-3 cursor-pointer"> Facturation Volants </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.billingSubscribedCheck" class="mb-5">
    <i v-tooltip="message3" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="billingSubscribedValueModel" input-id="billingSubscribedValue" name="billingSubscribedValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="billingSubscribedValue" class="text-surface-800 ml-3 cursor-pointer"> Facturation Abonnés </label>
  </div>

  <div
    v-if="selectedReporting !== null && initiallist[selectedReporting]?.valueDateFilterCheck && billingSubscribedValueModel === 1 && Number(selectedPeriodicityModel) !== 7"
    class="ml-12 mb-5"
  >
    <Checkbox v-model="valueDateFilterValueModel" input-id="valueDateFilterValue" name="valueDateFilterValue" :binary="true" :true-value="1" :false-value="0" size="small" class="mb-1" />
    <label for="valueDateFilterValue" class="text-sm text-surface-700 ml-2 cursor-pointer"> Filtrer par date de paiement </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.extensionSubscriptioncheck" class="mb-5">
    <i v-tooltip="message4" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="extensionsubscriptionvalueModel" input-id="extensionsubscriptionvalue" name="extensionsubscriptionvalue" :binary="true" :true-value="1" :false-value="0" />
    <label for="extensionsubscriptionvalue" class="text-surface-800 ml-3 cursor-pointer"> Extension Abonnés </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.cashdepositcheck" class="mb-5">
    <i v-tooltip="message5" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="cashDepositValueModel" input-id="cashDepositValue" name="cashDepositValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="cashDepositvalue" class="text-surface-800 ml-3 cursor-pointer"> Encaissements (Abonnements/Tickets) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.cashDepositCompleteCheck && cashDepositValueModel === 1" class="ml-12 mb-5">
    <Checkbox v-model="cashDepositCompleteValueModel" input-id="cashDepositCompleteValue" name="cashDepositCompleteValue" :binary="true" :true-value="1" :false-value="0" size="small" class="mb-1" />
    <label for="cashDepositCompleteValue" class="text-sm text-surface-700 ml-2 cursor-pointer"> Encaissement détaillé </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.unpaidmerchantcheck" class="mb-5">
    <i v-tooltip="message6" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="unpaidmerchantvalueModel" input-id="unpaidmerchantvalue" name="unpaidmerchantvalue" :binary="true" :true-value="1" :false-value="0" />
    <label for="unpaidmerchantvalue" class="text-surface-800 ml-3 cursor-pointer"> Impayés par marché et commerçant </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.unpaid16Check && unpaidmerchantvalueModel === 1" class="ml-10 mb-2">
    <Checkbox v-model="unpaidvalue16Model" input-id="unpaidvalue16" name="unpaidvalue16" :binary="true" size="small" class="mb-1" />
    <label for="unpaidvalue16" class="text-sm text-surface-700 ml-5"> Impayée </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.unpaid17Check && unpaidmerchantvalueModel === 1" class="ml-10 mb-2">
    <Checkbox v-model="unpaidvalue17Model" input-id="unpaidvalue17" name="unpaidvalue17" :binary="true" size="small" class="mb-1" />
    <label for="unpaidvalue17" class="text-sm text-surface-700 ml-5"> Impayée (À relancer) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.unpaid18Check && unpaidmerchantvalueModel === 1" class="ml-10 mb-2">
    <Checkbox v-model="unpaidvalue18Model" input-id="unpaidvalue18" name="unpaidvalue18" :binary="true" size="small" class="mb-1" />
    <label for="unpaidvalue18" class="text-sm text-surface-700 ml-5"> Impayée (Douteux) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.unpaid19Check && unpaidmerchantvalueModel === 1" class="ml-10 mb-5">
    <Checkbox v-model="unpaidvalue19Model" input-id="unpaidvalue19" name="unpaidvalue19" :binary="true" size="small" class="mb-1" />
    <label for="unpaidvalue19" class="text-sm text-surface-700 ml-5"> Impayée (Irrécouvrable) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.eventcheck" class="mb-5">
    <i v-tooltip="message7" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="eventvalueModel" input-id="eventvalue" name="eventvalue" :binary="true" :true-value="1" :false-value="0" />
    <label for="eventvalue" class="text-surface-800 ml-3 cursor-pointer"> Signalements</label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.eventinfractioncheck && eventvalueModel === 1" class="ml-10 mb-2">
    <Checkbox v-model="eventinfractionvalueModel" input-id="eventinfractionvalue" name="eventinfractionvalue" checked :binary="true" size="small" class="mb-1" />
    <label for="eventinfractionvalue" class="text-sm text-surface-700 ml-5"> Infractions </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.eventincidentcheck && eventvalueModel === 1" class="ml-10 mb-2">
    <Checkbox v-model="eventincidentvalueModel" input-id="eventincidentvalue" name="eventincidentvalue" :binary="true" size="small" class="mb-1" />
    <label for="eventincidentvalue" class="text-sm text-surface-700 ml-5"> Incidents Techniques, Matériel </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.eventvisitcheck && eventvalueModel === 1" class="ml-10 mb-5">
    <Checkbox v-model="eventvisitvalueModel" input-id="eventvisitvalue" name="eventvisitvalue" :binary="true" size="small" class="mb-1" />
    <label for="eventvisitvalue" class="text-sm text-surface-700 ml-5"> Visites (élus, Presse, Douanes, ...) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.recapmerchantcheck" class="mb-5">
    <i v-tooltip="message8" class="pi pi-info-circle text-primary-600 cursor-pointer mr-3" />
    <Checkbox v-model="recapMerchantValueModel" input-id="recapMerchantValue" name="recapMerchantValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="recapMerchantValue" class="text-surface-800 ml-3 cursor-pointer"> Récapitulatif commerçant </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.subscriptionincheck" class="mb-5">
    <Checkbox v-model="subscriptionInValueModel" input-id="subscriptionInValue" name="subscriptionInValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="subscriptionInValue" class="text-surface-800 ml-3 cursor-pointer"> Entrées (nouveaux abonnés) </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.subscriptionoutcheck" class="mb-5">
    <Checkbox v-model="subscriptionOutValueModel" input-id="subscriptionOutValue" name="subscriptionOutCheckValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="subscriptionOutValue" class="text-surface-800 mb-2 ml-3"> Sorties (fin d'abonnement) </label>
    <Message v-if="errorMessageOnglet2" severity="error" icon="pi pi-times-circle" variant="simple" size="small" class="mt-1 mb-3">
      {{ errorMessageOnglet2 }}
    </Message>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.incomewithplacercheck" class="mb-5">
    <Checkbox v-model="incomeWithPlacerValueModel" input-id="incomeWithPlacerValue" name="incomeWithPlacerValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="incomeWithPlacerValue" class="text-surface-800 ml-3 cursor-pointer"> Avec recettes par placier </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.chartscheck" class="mb-5">
    <Checkbox v-model="chartsValueModel" input-id="chartsValue" name="chartsValue" :binary="true" :true-value="1" :false-value="0" />
    <label for="chartsValue" class="text-surface-800 ml-3 cursor-pointer"> Enlever les graphiques </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.cityregroupcheck" class="mb-5">
    <div v-if="selectedReporting === 3 && ((selectedCity === -2 && cityRegroup2ValueModel === 0) || (selectedCity ?? 0) > 0)">
      <Checkbox v-model="cityRegroupValueModel" input-id="cityRegroupValue" name="cityRegroupValue" :binary="true" :true-value="1" :false-value="0" />
      <label for="cityRegroupValue" class="text-surface-800 ml-3 cursor-pointer"> {{ labelCityRegroup }} </label>
    </div>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.cityRegroup2Check && selectedCity === -2" class="mb-5">
    <Checkbox v-model="cityRegroup2ValueModel" input-id="cityRegroup2Value" name="cityRegroup2Value" :binary="true" :true-value="1" :false-value="0" />
    <label for="cityRegroup2Value" class="text-surface-800 ml-3 cursor-pointer"> Regrouper par ville </label>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.maskColumnCheck && [1, 2, 3].includes(selectedReporting)" class="mb-5">
    <div v-if="selectedReporting !== 1 || (selectedReporting === 1 && onlyOneOptionSelected)">
      <Checkbox v-model="maskColumnValueModel" input-id="maskColumnValue" name="maskColumnValue" :binary="true" :true-value="1" :false-value="0" size="small" class="mb-1" />
      <label for="maskColumnValue" class="text-surface-800 text-sm ml-3 mt-5"> Supprimer certaines colonnes </label>
      <div v-if="selectedReporting === 1 && unpaidmerchantvalueModel === 1 && maskColumnValueModel === 1">
        <Message severity="error" icon="pi pi-times-circle" variant="simple" size="small" class="mt-1 mb-3">
          Attention si vous cocher au moins une case, les impayés regroupés par marché n'apparaitront plus
        </Message>
      </div>
    </div>
  </div>

  <div v-if="selectedReporting !== null && initiallist[selectedReporting]?.maskColumnCheck && [1, 2, 3].includes(selectedReporting)" class="mb-5">
    <div v-if="selectedReporting !== 1 || (selectedReporting === 1 && onlyOneOptionSelected)">
      <div v-if="maskColumnValueModel === 1">
        <span class="block text-sm font-medium leading-6 text-surface-700 mb-2"> Colonnes à supprimer </span>
        <MultiSelect
          v-model="selectedColumnsModel"
          :options="columnMaskList"
          option-label="label"
          option-value="key"
          filter
          display="chip"
          :placeholder="columnMaskLoading ? 'Chargement des colonnes...' : 'Sélectionner des colonnes'"
          class="w-full md:w-[22rem] text-sm"
          :max-selected-labels="500"
          show-clear
          :loading="columnMaskLoading"
          panel-class="text-sm"
          :pt="{
            root: { class: 'flex-wrap items-start py-2 px-3' },
            label: { class: 'text-sm' },
            item: { class: 'py-2 px-3 text-sm' },
            header: { class: 'py-2 px-3 text-sm' },
            filterInput: { class: 'text-sm py-1' },
            token: { class: 'text-sm px-2 py-1 m-1 rounded bg-primary-100 text-primary-800' },
            trigger: { class: 'px-2' },
          }"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Checkbox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';

defineProps<{
  selectedReporting: number | null;
  selectedCity: number | null;
  initiallist: Record<number, Record<string, boolean>>;
  periodicities: Array<{ name: string; value: number }>;
  placers: Array<{ name: string; value: number }>;
  errorMessagePeriodicity: string;
  errorMessagePlacer: string;
  errorMessageOnglet: string;
  errorMessageOnglet2: string;
  labelCityRegroup: string;
  onlyOneOptionSelected: boolean;
  columnMaskList: Array<{ key: string; label: string }>;
  columnMaskLoading: boolean;
  message1: string;
  message2: string;
  message3: string;
  message4: string;
  message5: string;
  message6: string;
  message7: string;
  message8: string;
}>();

const selectedPeriodicityModel = defineModel<string>('selectedPeriodicity', { required: true });
const selectedPlacerModel = defineModel<string>('selectedPlacer', { required: true });
const absencesubscribedcheckvalueModel = defineModel<number>('absencesubscribedcheckvalue', { required: true });
const billingvolantcheckvalueModel = defineModel<number>('billingvolantcheckvalue', { required: true });
const billingSubscribedValueModel = defineModel<number>('billingSubscribedValue', { required: true });
const valueDateFilterValueModel = defineModel<number>('valueDateFilterValue', { required: true });
const extensionsubscriptionvalueModel = defineModel<number>('extensionsubscriptionvalue', { required: true });
const cashDepositValueModel = defineModel<number>('cashDepositValue', { required: true });
const cashDepositCompleteValueModel = defineModel<number>('cashDepositCompleteValue', { required: true });
const unpaidmerchantvalueModel = defineModel<number>('unpaidmerchantvalue', { required: true });
const unpaidvalue16Model = defineModel<boolean>('unpaidvalue16', { required: true });
const unpaidvalue17Model = defineModel<boolean>('unpaidvalue17', { required: true });
const unpaidvalue18Model = defineModel<boolean>('unpaidvalue18', { required: true });
const unpaidvalue19Model = defineModel<boolean>('unpaidvalue19', { required: true });
const eventvalueModel = defineModel<number>('eventvalue', { required: true });
const eventinfractionvalueModel = defineModel<boolean>('eventinfractionvalue', { required: true });
const eventincidentvalueModel = defineModel<boolean>('eventincidentvalue', { required: true });
const eventvisitvalueModel = defineModel<boolean>('eventvisitvalue', { required: true });
const recapMerchantValueModel = defineModel<number>('recapMerchantValue', { required: true });
const subscriptionInValueModel = defineModel<number>('subscriptionInValue', { required: true });
const subscriptionOutValueModel = defineModel<number>('subscriptionOutValue', { required: true });
const incomeWithPlacerValueModel = defineModel<number>('incomeWithPlacerValue', { required: true });
const chartsValueModel = defineModel<number>('chartsValue', { required: true });
const cityRegroupValueModel = defineModel<number>('cityRegroupValue', { required: true });
const cityRegroup2ValueModel = defineModel<number>('cityRegroup2Value', { required: true });
const maskColumnValueModel = defineModel<number>('maskColumnValue', { required: true });
const selectedColumnsModel = defineModel<string[]>('selectedColumns', { required: true });
</script>
